var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackedWN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "packed_w_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings_word",
    transform: "translate(-613.000000, -458.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618,458 C620.761424,458 623,460.238576 623,463 L623,473 C623,475.761424 620.761424,478 618,478 C615.238576,478 613,475.761424 613,473 L613,463 C613,460.238576 615.238576,458 618,458 Z M630,458 C632.761424,458 635,460.238576 635,463 L635,473 C635,475.761424 632.761424,478 630,478 C627.238576,478 625,475.761424 625,473 L625,463 C625,460.238576 627.238576,458 630,458 Z",
    id: "packed_w_n"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackedWN);
export default __webpack_public_path__ + "static/media/packed_w_n.70fa061f6e3cf5e61390da47ca8641bc.svg";
export { ForwardRef as ReactComponent };